
import { required } from 'vuelidate/lib/validators'

export default {
  person: {
    name: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/guest/list/resources/validations.js